{
  "dss": {
    "button": {
      "back": "Назад",
      "cancel": "Отказ",
      "close": "Затвори",
      "confirmDelete": "Да, изтрий",
      "continue": "Продължи",
      "logout": "Изход",
      "passwordReset": "Нулиране на парола",
      "save": "Запази",
      "verify": "Потвърди"
    },
    "error": {
      "403": "Нямате достъп до тази страница.",
      "404": "Тази страница не съществува.",
      "generic": "Възникна грешка. Моля, опитайте отново по-късно.",
      "invalidConfirmationLink": "Връзката за потвърждение е изтекла или е невалидна.",
      "throttling": "Твърде много опити. Операцията е временно блокирана.",
      "title": "Грешка",
      "title403": "Достъп отказан",
      "title404": "Не е намерено"
    },
    "footer": {
      "imprint": "Импресум",
      "legalEntity": "ANDREAS STIHL AG & Co. KG, D-71336 Waiblingen",
      "privacy": "Политика за поверителност",
      "terms": "Общи условия"
    },
    "label": {
      "CRMAccountNumber": "CRM номер на акаунт",
      "contact": "Контакт",
      "email": "Имейл",
      "faq": "ЧЗВ",
      "female": "Г-жа",
      "firstname": "Име",
      "help": "Помощ",
      "language": "Език",
      "lastname": "Фамилия",
      "male": "Г-н",
      "needHelp": "Нуждаете се от помощ?",
      "newPassword": "Нова парола",
      "newPassword2": "Потвърдете новата парола",
      "oldPassword": "Текуща парола",
      "organization": "Организация",
      "password": "Парола",
      "required": "задължително",
      "salutation": "Обръщение",
      "select": "Моля, изберете"
    },
    "lang": {
      "de": "Немски"
    },
    "link": {
      "contact": "https://support.stihl.com/en-INT/websso-ext-contact/",
      "faq": "https://support.stihl.com/en-INT/externalkbsearchwebsso/"
    },
    "page": {
      "confirm": {
        "title": "Потвърждение на регистрация",
        "wait": "Моля, изчакайте, за да завърши потвърждаването на акаунта."
      },
      "otp": {
        "btnResend": "Изпрати кода за потвърждение отново",
        "msg": {
          "invalidOTP": "Въведената еднократна парола е невалидна.",
          "resendFail": "Неуспешно изпращане на кода. Моля, опитайте отново по-късно."
        },
        "spamDetail": "Проверете входящата си поща и папка Спам за имейл от STIHL Support (noreply{'@'}stihl-sso.com)",
        "spamTitle": "Не получихте имейл?",
        "subtitle": "За да продължите, трябва да потвърдите своя имейл адрес.",
        "title": "Потвърдете своя потребителски акаунт",
        "txtVerifyMail": "Моля, въведете новия код за потвърждение, който изпратихме на вашия имейл адрес {email}"
      },
      "personal": {
        "msg": {
          "noChange": "Няма промени за обновяване.",
          "updateError": "Неуспех при обновяване на личните данни.",
          "updated": "Личните данни бяха обновени.",
          "userLoadErr": "Грешка при зареждане на потребителските данни. Моля, опитайте отново по-късно."
        },
        "secOrganization": "Организация",
        "secPersonal": "Лични",
        "secSettings": "Предпочитани настройки",
        "title": "Лична информация"
      },
      "postPwSet": {
        "info": "Вече можете да използвате новата си парола.",
        "link_name": "Продължи към Self-Service",
        "link_url": "/user/ui/",
        "title": "Вашата парола беше променена"
      },
      "resetPW": {
        "title": "Нулирайте паролата си"
      },
      "security": {
        "2fa": {
          "availableMethods": "Налични 2FA методи:",
          "info": "Двуфакторната автентикация (2FA) е функция за сигурност, която добавя допълнителен слой защита към вашия акаунт. Тя изисква да използвате два метода за вход вместо само потребителско име и парола.",
          "method": {
            "email": "Имейл",
            "emailDesc": "Получавайте еднократни кодове по имейл, за да завършвате заявки за автентикация.",
            "oath": {
              "add": {
                "button": "Регистрирай приложение Authenticator"
              }
            }
          }
        },
        "authenticator": "Приложение за удостоверяване",
        "infoFederatedAccount": "Този акаунт се управлява от доставчика на самоличност на вашата организация, затова паролата не може да бъде променена оттук. За да промените паролата си, влезте през страницата за вход на вашата организация или се свържете с вашия ИТ администратор.",
        "lastUse": "Последно използвано на {0}.",
        "msg": {
          "invalidPassword": "Предоставената текуща парола е невалидна.",
          "passwordAlreadyUsed": "Не може да се използват последните 5 пароли.",
          "pwUpdateError": "Възникна грешка при опит за смяна на паролата.",
          "pwUpdated": "Паролата беше променена."
        },
        "noDevice": "Не е конфигуриран",
        "oathAdd": {
          "appInfo": "За да улесните процеса на вход в STIHL, можете да използвате приложения за удостоверяване като {0}, {1}, {2} и др., за да генерирате еднократни пароли, които се използват като втори фактор по време на процеса на вход.<br/>Ако сте загубили или забравили мобилното си устройство, винаги можете да използвате 2FA кода, изпратен по имейл.<br/><br/>Моля, следвайте инструкциите по-долу, за да настроите устройството си за удостоверяване.",
          "badCode": "Невалиден код, моля опитайте отново.",
          "error": "Възникна грешка при опит за регистрация на устройството за удостоверяване.",
          "headScan": "1. Сканирайте QR кода с вашето приложение за удостоверяване",
          "headVerify": "2. Потвърдете кода",
          "infoKey": "ключ за настройка",
          "infoKeyTitle": "Вашата тайна за двуфакторно удостоверяване",
          "infoScanBottom": "Не можете да сканирате? Можете да използвате {0}, за да конфигурирате ръчно вашето приложение за удостоверяване.",
          "infoVerify": "Въведете кода, генериран от вашето приложение за удостоверяване.",
          "success": "Вашето устройство за удостоверяване е регистрирано. Вече можете да го използвате за вход.",
          "title": "Регистрирайте вашето устройство за двуфакторно удостоверяване"
        },
        "oathDelete": {
          "error": "Възникна грешка при опит за изтриване на устройството за удостоверяване.",
          "success": "Устройството за удостоверяване беше изтрито."
        },
        "passkeys": {
          "about": {
            "info1": "Passkey са двойки криптографски ключове (публичен и частен ключ), които се съхраняват от удостоверител, който контролирате. Удостоверителят може да докаже, че потребителят е налице и е упълномощен да използва passkey. Удостоверителите доказват упълномощаването с PIN, код, биометрия или парола на устройството в зависимост от възможностите и настройките им. Удостоверителите могат да бъдат различни – iPhone или Android устройство, Windows Hello, FIDO2 хардуерен ключ за сигурност или мениджър на пароли.",
            "info2": "Когато влизате в STIHL с passkey, вашият удостоверител използва криптография с публичен ключ, за да докаже вашата самоличност пред STIHL, без никога да изпраща самия passkey. Passkey са обвързани с домейн на уебсайт, като stihl-sso.com, и изискват сигурна връзка, което означава, че браузърът ще откаже удостоверяване към фишинг сайт. Тези свойства правят passkey силно устойчиви на фишинг и много по-трудни за атака от SMS или TOTP 2FA, които могат да бъдат фишнати.",
            "info3": "Услугите за passkey с облачна синхронизация позволяват ключовете да се синхронизират между устройствата (като устройства на Apple, Android или мениджъри на пароли), така че да могат да се използват на повече места и по-трудно да се изгубят. След като настроите синхронизиран passkey на едно устройство, той е наличен за използване на множество устройства, използващи същата услуга. Например, ако регистрирате passkey с вашия iCloud акаунт чрез Touch ID на вашия MacBook, след това можете да използвате този passkey с лице, пръстов отпечатък, PIN или парола на устройството взаимозаменяемо на няколко устройства, свързани със същия iCloud акаунт.",
            "title": "Относно Passkeys"
          },
          "add": {
            "button": "Добавяне на нов Passkey",
            "error": "Възникна грешка при опит за добавяне на нов passkey.",
            "success": "Добавен е нов passkey."
          },
          "delete": {
            "button": "Изтриване на Passkey",
            "error": "Възникна грешка при опит за изтриване на този passkey.",
            "success": "Passkey беше изтрит."
          },
          "edit": {
            "error": "Възникна грешка при опит за запазване на името на passkey.",
            "name": "Име на Passkey",
            "success": "Името на passkey беше обновено.",
            "title": "Дайте име на вашия passkey, за да го различавате от други"
          },
          "info": "Passkey е прост и сигурен заместител на паролите, който валидира вашата самоличност чрез докосване, лицево разпознаване, парола на устройство или PIN.",
          "none": "Няма конфигуриран Passkey.",
          "reallyDelete": "Сигурни ли сте, че искате да изтриете Passkey?",
          "registeredPasskeys": "Вашите регистрирани Passkey:",
          "title": "Passkeys"
        },
        "reallyDeleteDevice": "Сигурни ли сте, че искате да изтриете устройството за удостоверяване?",
        "secMFA": "Двуфакторна автентикация",
        "secPwdChange": "Смяна на парола",
        "title": "Сигурност"
      },
      "setPW": {
        "acceptTC": "Моля, потвърдете нашите {terms} и прочетете нашата {privacy}.",
        "killSSO": "Прекратяване на всички активни сесии",
        "msg": {
          "tokenExpired": "Връзката или кодът за парола са изтекли. Моля, следвайте връзката, за да нулирате паролата си: {link}."
        },
        "privacy": "Политика за защита на данните",
        "terms": "Общи условия",
        "title": "Въведете нова парола"
      }
    },
    "validations": {
      "hasDigit": "Трябва да съдържа цифра(и)",
      "hasLowercase": "Трябва да съдържа малки букви",
      "hasSpecial": "Трябва да съдържа специални символи: {chars}",
      "hasUppercase": "Трябва да съдържа главни букви",
      "invalidCharacters": "Съдържа невалидни знаци",
      "maxLength": "Позволени са максимум {max} знака",
      "minLength": "Изискват се минимум {min} знака",
      "notSameAsEmail": "Твърде подобна на имейл адреса",
      "onlyValidCharactersAllowed": "Разрешени са само букви, цифри и интервали.",
      "required": "Задължително поле",
      "sameAsPassword": "Паролите не съвпадат",
      "tcAccepted": "Моля, потвърдете нашите общи условия.",
      "validEmail": "Невалиден имейл адрес.",
      "validOTP": "Моля, въведете кода за потвърждение."
    }
  }
}
